import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user';
import report from './modules/report';
import survey from './modules/survey';
import client from './modules/client';
import labcorp from './modules/labcorp';
import profile from './modules/profile';
import coupon from './modules/coupon';
import provider from './modules/provider';
import tag from './modules/tag';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    report,
    survey,
    client,
    labcorp,
    profile,
    coupon,
    provider,
    tag
  },
});

export default store;